import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";
import { isMainSiteCode } from "Utils/siteConfig";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
			"& img": {
				width: "100%",
			},
			"& p, & > div": {
				fontFamily: theme.fonts.light,
				fontSize: "16px",
				lineHeight: 1.5,
				color: theme.palette.colors.oneMoreGrey,
				padding: 0,
				display: "block",
				margin: "10px 0",
			},
			"& table": {
				width: "100%",
				margin: "20px 0",
			},
			"& p:first-child": {
				marginTop: 0,
			},
			"& p:last-child": {
				marginBottom: 0,
			},
			"& h2": {
				color: theme.palette.colors.charcoalGrey,
				fontFamily: theme.fonts.light,
			},
			"& li": {
				listStyle: "none",
			},
			"& a": {
				color: theme.palette.colors.purplishBlue,
			},
		},
		tablePersonalData: {
			"& table#disposal": {
				width: "100%",
				margin: "20px 0",
				borderCollapse: "collapse",
				border: `1px solid ${theme.palette.colors.black}`,
				color: theme.palette.colors.oneMoreGrey,
				"& th, td": {
					padding: "7px",
					border: `1px solid ${theme.palette.colors.black}`,
					textAlign: "justify",
					verticalAlign: "top",
					wordBreak: "break-all",
				},
				"& th:nth-child(1), td:nth-child(1)": {
					width: "10%",
				},
				"& th:nth-child(2), td:nth-child(2)": {
					width: "20%",
				},
				"& th:nth-child(3), td:nth-child(3)": {
					width: "40%",
				},
				"& th:nth-child(4), td:nth-child(4)": {
					width: "30%",
				},
			},
			"& table#person": {
				width: "100%",
				margin: "20px 0",
				borderCollapse: "collapse",
				border: `1px solid ${theme.palette.colors.black}`,
				color: theme.palette.colors.oneMoreGrey,
				"& th, td": {
					padding: "7px",
					border: `1px solid ${theme.palette.colors.black}`,
					textAlign: "left",
					verticalAlign: "top",
					wordBreak: "break-all",
				},
				"& th:nth-child(1), td:nth-child(1)": {
					width: "30%",
				},
				"& th:nth-child(2), td:nth-child(2)": {
					width: "30%",
				},
				"& th:nth-child(3), td:nth-child(3)": {
					width: "15%",
				},
				"& th:nth-child(4), td:nth-child(4)": {
					width: "15%",
				},
				"& th:nth-child(5), td:nth-child(5)": {
					width: "10%",
				},
			},
			"& p:first-child": {
				marginTop: 0,
			},
			"& p:last-child": {
				marginBottom: 0,
			},
			"& h2": {
				color: theme.palette.colors.charcoalGrey,
				fontFamily: theme.fonts.light,
			},
			"& li": {
				listStyle: "none",
			},
		},
		tablePersonalDataPerson101: {
			"& table#person": {
				"& th:nth-child(1), td:nth-child(1)": {
					width: "30%",
				},
				"& th:nth-child(2), td:nth-child(2)": {
					width: "30%",
				},
				"& th:nth-child(3), td:nth-child(3)": {
					width: "20%",
				},
				"& th:nth-child(4), td:nth-child(4)": {
					width: "20%",
				},
			},
		},
		liStyleDisc: {
			"& li": {
				listStyle: "disc",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				"& p, >div": {
					fontSize: "14px",
					lineHeight: "1.43",
				},
				"& h2": {
					fontSize: "20px",
				},
			},
		},
	};
};

class TextBlock extends React.Component {
	static defaultProps = {
		text: null,
	};

	render() {
		let classes = this.props.classes;
		if (this.props.noDangerously) {
			return (
				<div
					className={classNames(classes.root, {
						[classes.liStyleDisc]: this.props.liStyleDisc,
						[classes.tablePersonalData]: this.props.changeTable,
						[classes.tablePersonalDataPerson101]: isMainSiteCode(this.props.siteCode),
					})}
				>
					{this.props.text}
				</div>
			);
		}
		return (
			<div
				className={classNames(classes.root, {
					[classes.liStyleDisc]: this.props.liStyleDisc,
					[classes.tablePersonalData]: this.props.changeTable,
					[classes.tablePersonalDataPerson101]: isMainSiteCode(this.props.siteCode),
				})}
				dangerouslySetInnerHTML={{
					__html: this.props.text,
				}}
			/>
		);
	}
}

export default withStyles(styles)(TextBlock);
